import React from 'react'
import data from './data'
import './speaker.css'


const Speakers = () => {
  return (
   <section id="price">
    <h2>Pricing</h2>
      <div className="speaker_container">
          
          {
            data.map(item => <div key={item.id} className="speaker__img">
                      <span className='speaker_name'>{item.name}</span> 
                      <img src={item.image} alt='image item' className='imageItem'/>
                  
                      <strong className='price'>₦{item.price}</strong>  <br></br>     
                      <i className='description'>{item.desc}</i> <br></br>   
                      <i className='description'>{item.add}</i> 
                      <a href="#footer" className='btn btnx primary'>Hire Now</a>
                      <div>
                      {/* <i className='facebook'>{item.facebook}</i> 
                      <i className='instagram'>{item.instagram}</i> 
                      <i className='twitter'>{item.twitter}</i>  */}
                      </div>
            </div>)

          } 

      </div>
   </section>
  )
}

export default Speakers
